<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :span="5" @click="uploadBtn++">
            <a-form-item label="表单名称">
              <j-input placeholder="请输入表单名称" v-model="queryParam.name" ></j-input>
            </a-form-item>
          </a-col>

          <a-col :span="5">
            <a-form-item label="英文名称">
              <j-input placeholder="请输入英文名称" v-model="queryParam.nameEn"></j-input>
            </a-form-item>
          </a-col>

          <a-col :span="5">
            <a-form-item label="表单类型">
              <a-radio-group v-model="queryParam.type">
                <a-radio value="1">表单</a-radio>
                <a-radio value="2">量表</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>

          <a-col :span="5">
            <a-form-item label="状态">
              <a-radio-group v-model="queryParam.status">
                <a-radio value="1">正常</a-radio>
                <a-radio value="0">停用</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>

          <a-col :span="4">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary"  @click="searchQuery" icon="search">查询</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>

                </span>
          </a-col>
          <a-col :span="4">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button @click="handleAdd" type="primary" icon="plus" style="margin-left: 8px">新增</a-button>
                  <a-button @click="handleAddByExist" type="primary" icon="plus" style="margin-left: 8px">表单复制</a-button>
                </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"

        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="view(record)">预览</a>
          <a-divider type="vertical" />
          <template >
            <a-upload name="file" :data="{formId:record.id}" :showUploadList="false" :multiple="false" :headers="tokenHeader" style="margin-left: 8px" :action="importExcelUrl" @change="handleImportExcel">
                           <a >导入</a>
                  </a-upload>
                 <a-divider type="vertical" />
          </template>
         <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a href="javascript:;" @click="handleEdit(record)">编辑</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="formItemSetHandle(record)">表单设置</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="historyHandle(record)">历史版本</a>
              </a-menu-item>   
               <a-menu-item v-has="'projectform:audit'">
                <a @click="addFormHandle(record)">表单补录</a>
              </a-menu-item>           
              <a-menu-item>
                <a-popconfirm title="确认立即生效吗？确认后，已入组的受试者将使用新版本的表单随访！" @confirm="() => useForm(record.id)">
                  <a>立即生效</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;" v-if="record.status==='1'" @click="handleEditStatus(record.id,'2')">停用</a>
                <a href="javascript:;" v-else @click="handleEditStatus(record.id,'1')">启用</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <form-item-set ref="formItemSet" @onClose="loadData"></form-item-set>
    <!-- table区域-end -->
    <!-- 表单区域 -->
    <projectForm-modal ref="modalForm" @ok="modalFormOk" :projectId="projectId"></projectForm-modal>
    <a-drawer
      title="预览"
      width="60%"
      :closable="false"
      @close="onViewClose"
      :visible="viewVisible"
    >
      <div style="font-size: 18px;font-weight: bold;text-align: center;margin-bottom: 10px">
        {{current.name}}
      </div>
      <form-view :base-data="current">

      </form-view>
    </a-drawer>
    <a-modal
      title="已有表单新增"
      :width="800"
      :visible="addExist.visible"
      :confirmLoading="addExist.loading"
      switchFullscreen
      @ok="handleAddExistOk"
      @cancel="handleAddExistCancel"
      cancelText="关闭">
      <a-form-model layout="horizontal" :model="addExist.model" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 },}" ref="addExistRuleForm" :rules="addExist.rules">
        <a-form-model-item  prop="projectId" label="项目">
          <a-select
            placeholder="请选择"
            v-model="addExist.model.projectId"
            @change="projectIdChange"
            showSearch
            :filterOption="filterOption"
          >
            <a-select-option :value="item.id" v-for="item in projectList">{{item.name}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item prop="formId" label="表单">
          <a-select
            placeholder="请选择"
            v-model="addExist.model.formId"
            showSearch
            :filterOption="filterOption"
          >
            <a-select-option :value="item.id" v-for="item in formList">{{item.name}}</a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal
      title="历史版本"
      :width="600"
      :visible="historyVisible"
      switchFullscreen
      :footer="null"
      @cancel="historyVisible=false">
      <div class="history-div" v-for="(item,index) in historyList" :key="index">
        <div>
          <label class="title">
            历史创建时间：
          </label>
          <label class="time">
            {{item.historyCreateTime}}
          </label>
          <a-button class="btn" size="small" type="primary" @click="historyView(item)">查看</a-button>
        </div>
        <div class="description">

        </div>
      </div>

    </a-modal>
   <a-modal
    title="表单补录信息"
    :width="800"
    :visible="addFormVisible"
    switchFullscreen
    :bodyStyle="{ maxHeight: '80vh', overflowY: 'auto' }"
    @cancel="addFormVisible = false"
  >
    <div>
      <label class="title">请选择表单补录周期：</label>
      <a-radio-group v-model="periodItemId">
        <a-radio v-for="item in periodItemList" :key="item.id" :value="item.id">
          {{ item.name }}
        </a-radio>
      </a-radio-group>
    </div>

    <!-- footer 插槽：右对齐按钮，固定在 modal 底部 -->
    <template #footer>
      <div class="modal-footer">
        <a-button size="small" @click="addFormVisible = false">取消</a-button>
        <a-button class="ml8" size="small" type="primary" @click="saveForm()">
          开始补录
        </a-button>
      </div>
    </template>
  </a-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import ProjectFormModal from './form/ProjectFormModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME } from '@/constants/project'
  import { getAction,postAction } from '@/api/manage'
  import Vue from 'vue'
  import JInput from '@/components/jeecg/JInput'
  import FormView from '../components/FormView'
  import FormItemSet from './form/FormItemSet'
  import ARadioGroup from 'ant-design-vue/es/radio/Group'
  import baseRules from '@/constants/baseRules'
  export default {
    name: "Form",
    mixins:[JeecgListMixin],
    components: {
      ARadioGroup,
      FormItemSet,
      FormView,
      JInput,
      ProjectFormModal
    },
    data () {
      return {
        description: '项目受试者自定义配置管理页面',
        uploadBtn:0,
        // 表头
        columns: [

          {
            title: '表单名称',
            align:"center",
            dataIndex: 'name'
          },
		   {
            title: '英文名称',
            align:"center",
            dataIndex: 'nameEn'
           },

          {
            title: '表单类型',
            align:"center",
            dataIndex: 'type_dictText'
          },
          {
            title: '表单项数',
            align:"center",
            dataIndex: 'itemCount'
          },
		   {
            title: '状态',
            align:"center",
            dataIndex: 'status_dictText'
           },
          {
            title: '表单说明',
            align:"center",
            ellipsis: true,
            dataIndex: 'description'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
		    url: {
          list: "/project/projectForm/listAll",
          delete: "/project/projectForm/delete",
       },
        disableMixinCreated:true,
        viewVisible:false,
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        current:{},

        addExist:{
          visible:false,
          loading:false,
          rules:{
            projectId:[baseRules.required],
            formId:[baseRules.required],
          },
          model:{},
        },
        projectList:[],
        formList:[],
        historyList:[],
        periodItemList:[],
        periodItemId:null,
        historyVisible:false,
        addFormVisible:false,
        formItem:{},
      }
  },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/project/projectForm/importExcel`;
      }
    },
    mounted(){
      this.baseQueryParam = {projectId:this.projectId}
      this.loadData()
      this.loadProjectList()
    },
    methods: {
      handleAddByExist(){
        this.addExist.visible = true
      },
      handleAddExistCancel(){
        this.addExist.model = {}
        this.addExist.visible = false
      },
      handleAddExistOk(){
        this.$refs.addExistRuleForm.validate(valid  => {
          if(valid){
            this.addExist.loading = true
            postAction('/project/projectForm/addExist',{projectId:this.projectId,formId:this.addExist.model.formId}).then(res=>{
              if(res.success){
                this.handleAddExistCancel()
                this.loadData()
              }
            }).finally(()=>{
              this.addExist.loading = false
            })
          }

        })
      },
      projectIdChange(){
        getAction('/project/projectForm/listAll',{projectId:this.addExist.model.projectId}).then(res=>{
          if(res.success){
            this.formList = res.result
          }
        })
      },
      loadProjectList(){
        getAction('/management/project/listAll').then(res=>{
          if(res.success){
            this.projectList = res.result
          }
        })
      },

      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },

      formItemSetHandle(record){
        this.$refs.formItemSet.view(record,this.dataSource)
      },
      useForm(id){
        postAction('/project/projectForm/useForm?formId='+id).then(res=>{
          if(res.success){            
            this.$message.success(res.result)
          }else{
            this.$message.warning(res.message)
          }
        })
      },
      onViewClose(){
        this.viewVisible = false
      },
      view(record){
        this.addFormId=record.id
        getAction('/project/projectForm/getInfoById',{id:record.id}).then(res=>{
          if(res.success){
            this.current = res.result
            this.viewVisible = true
          }
        })
      },
      handleEditStatus(id,status){
        postAction('/project/projectForm/editStatus',{id:id,status:status}).then(res=>{
          if(res.success){
            this.loadData()
          }else{
            this.$message.warning(res.message)
          }
        })
      },
      historyHandle(record){
        getAction('/project/projectForm/historyList',{id:record.id}).then(res=>{
          if(res.success){
            this.historyList = res.result
            if(this.historyList.length){
              this.historyVisible = true
            }else{
              this.$message.warning('该表单当前没有历史版本')
            }
          }
        })
      },

      addFormHandle(record){
        this.formItem = record
        getAction('/project/projectPeriodItem/list',{projectId:record.projectId}).then(res=>{
           if(res.success){
            this.periodItemList = res.result
            if(this.periodItemList.length){
              this.addFormVisible = true
            }else{
              this.$message.warning('该表单所在项目尚未创建周期项目，无法补录表单')
            }
          }
        })
      },
      
      historyView(record){
        this.historyVisible=false
        this.view(record)
      },

      //将所选择表单添加到已入组的所有受试者对应周期
      saveForm(){
        getAction('/patient/patientPeriodItem/addFormForPatients', { periodId: this.periodItemId, formId: this.formItem.id }).then(res => {
                if (res.success) {
                    this.$message.success('表单补录操作已启动，系统正在后台处理，请稍后查看结果！');
                    this.addFormVisible = false;
                } else {
                    this.$message.warning(res.message);
                     this.addFormVisible = false;
                }
        });
      },
    }
  }
</script>
<style scoped lang="less">
  @import '~@assets/less/common.less';
  .history-div{
    margin: 0px 20px 20px 20px;
    text-align: center;
    .title{

    }
    .time{
      color: @primary-color;
      margin: 0px 20px;
    }
    .btn{

    }
    .modal-footer {
  display: flex;
  justify-content: flex-end; /* 右对齐 */
  gap: 8px; /* 按钮间距 */
  padding: 8px 0; /* 可根据需要微调 */
}
.ml8 { margin-left: 8px; }
  }
</style>